<template>
  <div class="expert-container">
    <custom-router-link :item="info" class="expert-link" :to="{name: 'HomeExpertDetails', params: {id: info.id}}" target="_blank">
      <el-image :src="require('@/assets/images/expert_bg.png')" fit="cover" style="width: 100%; height: 130px"></el-image>
      <div class="expert-image">
        <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
        <el-image :src="require('@/assets/images/img1.png')" fit="cover" v-else></el-image>
      </div>
      <div class="expert-details">
        <div class="expert-title">{{info.name}}</div>
        <div class="expert-summary">{{info.summary}}</div>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.expert-container {
  width: 100%;
  height: 300px;
  .expert-link {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.08);
    position: relative;
    .expert-image {
      width: 130px;
      height: 130px;
      border-radius: 100%;
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 60px;
      transform: translateX(-50%);
      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.08);
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .expert-details {
      width: 100%;
      padding: 80px 20px 20px;
      height: 200px;
      .expert-title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 10px;
        color: #212529;
        text-align: center;
      }
      .expert-summary {
        font-size: 15px;
        color: #6c757d;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .expert-container {
    width: 100%;
    height: auto;
    aspect-ratio: 1/1;
    overflow: hidden;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.04);
    margin: 10px 0;
    .expert-link {
      box-shadow: none;
      height: 100%;
      .expert-image {
        width: 110px;
        height: 110px;
        top: 50px;
        box-shadow: none;
      }
      .expert-details {
        width: 100%;
        padding: 56px 24px 14px;
        height: 200px;
        .expert-title {
          font-weight: 600;
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 10px;
          color: #212529;
          text-align: center;
        }
        .expert-summary {
          font-size: 14px;
          color: #6c757d;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>